import { Component, Injector, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { FormType } from 'src/app/common/enumerations/enumerations';
import { TransactionLogService } from 'src/app/services/logs/transaction-log.service';
import { TransactionLog } from 'src/app/services/logs/transaction-logs';
import { TransactionLogAmendmentsComponent } from './transaction-log-amendments/transaction-log-amendments.component';

@Component({
  selector: 'transaction-log',
  templateUrl: './transaction-log.component.html',
  styleUrls: ['./transaction-log.component.scss']
})
export class TransactionLogComponent extends BaseComponent implements OnChanges, OnDestroy {
  @Input() serialNo?: string;
  @Input() formType?: FormType;

  transactionLogs?: TransactionLog[];
  transactionLogsFiltered?: TransactionLog[];
  transactionLogs$!: Observable<TransactionLog[]>;
  transactionLogsSubs!: Subscription;

  @ViewChild(TransactionLogAmendmentsComponent) amendments!: TransactionLogAmendmentsComponent;

  constructor(
    protected override injector: Injector,
    private service: TransactionLogService
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadTransactionLogs();
  }

  override ngOnDestroy(): void {
    this.transactionLogsSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  loadTransactionLogs() {
    this.transactionLogs$ = this.store.select(state => state.TransactionLog.data);
    this.transactionLogsSubs = this.transactionLogs$.subscribe(data => {
      const transactionLogs = data?.filter(t => t.serialNo == this.serialNo);
      if (transactionLogs.length) {
        this.transactionLogs = transactionLogs.sort((a, b) => this.utils.sort(a.createdOn, b.createdOn));
        this.amendments?.refresh();
      }
      else {
        if (this.serialNo)
          this.service.GetBySerialNo(this.serialNo).toPromise().then(data => {
            this.transactionLogs = data?.sort((a, b) => this.utils.sort(a.createdOn, b.createdOn));
          });
      }
    });
  }

}
